@if (hasHeader) {
    <ng-content select="[header]"/>
}
@if (hasMain) {
    <ng-content select="[main]"/>
}
